import { z } from "zod"

import { PricingNumericTypeValues } from "@/screens/Pricing/constants"

export const BulkUpdateSchema = z
  .object({
    acceptedCost: z.number().optional().nullable(),
    acceptedCostType: z.nativeEnum(PricingNumericTypeValues).optional(),
    maintainMargin: z.boolean().optional(),
    priceChange: z.number().optional().nullable(),
    priceChangeType: z.nativeEnum(PricingNumericTypeValues).optional(),
    expirationDate: z.string().nullable().optional(),
    effectiveDate: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (
      (data.maintainMargin && data.acceptedCost === null) ||
      (data.maintainMargin && data.acceptedCost === undefined)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Desired Accepted Cost is required when Maintain margins is checked",
        path: ["acceptedCost"],
      })
    }
  })

export type BulkUpdateFormValues = z.infer<typeof BulkUpdateSchema>
